/**
 * 将指定资源添加到收藏夹。
 *
 * @param resourceId - 资源的 ID。
 * @param resourceType - 资源的类型。
 * @param collectionId - 收藏夹的 ID。
 * @returns 返回添加到收藏夹的 Promise。
 *
 * @remarks
 * 该函数发送请求以将指定资源添加到收藏夹。需要提供资源的 ID、类型以及收藏夹的 ID。
 * 请注意，如果发生请求失败，错误将不会在此处捕获，而是被传递给调用方处理。
 *
 * @example
 * ```typescript
 * await requestAddResToCollection(123, 1, 456);
 * ```
 */
export async function requestAddResToCollection(
  resourceId: number,
  resourceType: number,
  collectionId: number
) {
  return http.post('/v1/favorite/add_favorite', {
    resource_id: resourceId,
    type: resourceType,
    list_id: collectionId
  })
}
